import diviCamaras from '../assets/icons/divi-accesos/camaras.svg';
import diviCentinela from '../assets/icons/divi-accesos/centinela.svg';
import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';

import puzzleIcon from '../assets/icons/maccez-puzzle-icon.png';
import iconocentinel from '../assets/icons/iconosestados/iconocentinel.png';

/* =========================================================
   ICONOS MÓVILES MONOCROMÁTICOS
   ========================================================= */

function GlobeIcon() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyles.svg}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.4 2.5 3.6 5.5 3.6 9S14.4 18.5 12 21" />
      <path d="M12 3C9.6 5.5 8.4 8.5 8.4 12S9.6 18.5 12 21" />
    </svg>
  );
}

function VehicleIcon() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyles.svg}>
      <path d="M5 16.5V11l2-5h10l2 5v5.5" />
      <path d="M7 11h10" />
      <path d="M8 15h.01" />
      <path d="M16 15h.01" />
      <path d="M6 18.5h2" />
      <path d="M16 18.5h2" />
      <path d="M5 16.5h14" />
    </svg>
  );
}

function CameraIcon() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyles.svg}>
      <rect x="3" y="6.5" width="13" height="11" rx="2.5" />
      <path d="m16 10 5-2.5v9L16 14" />
      <circle cx="9.5" cy="12" r="2.5" />
    </svg>
  );
}

function ControlIcon() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyles.svg}>
      <path d="M4 7h10" />
      <path d="M18 7h2" />
      <circle cx="16" cy="7" r="2" />

      <path d="M4 17h2" />
      <path d="M10 17h10" />
      <circle cx="8" cy="17" r="2" />

      <path d="M4 12h5" />
      <path d="M13 12h7" />
      <circle cx="11" cy="12" r="2" />
    </svg>
  );
}

function AccountIcon() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyles.svg}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4.5 21c.7-4.2 3.2-6.4 7.5-6.4s6.8 2.2 7.5 6.4" />
    </svg>
  );
}

function SentinelIcon() {
  return (
    <svg viewBox="0 0 24 24" style={iconStyles.svg}>
      <path d="M12 3 19 6v5c0 4.6-2.8 8.1-7 10-4.2-1.9-7-5.4-7-10V6l7-3Z" />
      <path d="M9.2 12.1 11.2 14l3.8-4" />
    </svg>
  );
}

function Sidebar({ moduloActivo, setModuloActivo }) {
  const [isMobile, setIsMobile] = useState(isMobileLayout);
  const [hubAbierto, setHubAbierto] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(isMobileLayout());
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    setHubAbierto(false);
  }, [moduloActivo]);

  useEffect(() => {
  const cerrarHubMovil = () => {
    setHubAbierto(false);
  };

  window.addEventListener(
    'maccez:mobile-hub-close',
    cerrarHubMovil
  );

  return () => {
    window.removeEventListener(
      'maccez:mobile-hub-close',
      cerrarHubMovil
    );
  };
}, []);

useEffect(() => {
  if (!hubAbierto) {
    return;
  }

  const cerrarHubAlTocarAfuera = (
    event
  ) => {
    const target =
      event.target;

    /*
      Si el toque ocurrió dentro del menú
      MACCEZ, dejamos que sus botones
      trabajen normalmente.
    */
    if (
      target instanceof Element &&
      target.closest(
        '[data-maccez-hub-root="true"]'
      )
    ) {
      return;
    }

    /*
      Cerramos el Hub, pero no utilizamos
      preventDefault ni stopPropagation.

      Así el mismo toque o gesto continúa
      inmediatamente hacia Google Maps.
    */
    setHubAbierto(false);
  };

  window.addEventListener(
    'pointerdown',
    cerrarHubAlTocarAfuera,
    true
  );

  return () => {
    window.removeEventListener(
      'pointerdown',
      cerrarHubAlTocarAfuera,
      true
    );
  };
}, [hubAbierto]);


const mobileLeftItems = [
  {
    id: 'mapa',
    nombre: 'Mapa',
    Icon: GlobeIcon
  },
  {
    id: 'vehiculos',
    nombre: 'Activos',
    Icon: VehicleIcon
  }
];

const mobileRightItems = [
  {
    id: 'control',
    nombre: 'Control',
    Icon: ControlIcon
  },
  {
    id: 'cuenta',
    nombre: 'Mi cuenta',
    Icon: AccountIcon
  }
];

const navegarMovil = (modulo) => {
  setHubAbierto(false);
  setModuloActivo(modulo);
};

const renderMobileItem = (item) => {
  const activo =
    moduloActivo === item.id;

  const Icon = item.Icon;

  return (
    <button
      key={item.id}
      type="button"
      aria-label={item.nombre}
      aria-current={
        activo ? 'page' : undefined
      }
      onClick={() => {
        navegarMovil(item.id);
      }}
      style={mobileStyles.item}
    >
      <span
        style={{
          ...mobileStyles.activeCapsule,

          opacity:
            activo ? 1 : 0,

          transform:
            activo
              ? 'scale(1)'
              : 'scale(0.92)'
        }}
      />

      <span
        style={{
          ...mobileStyles.content,

          color: '#111111',

          transform:
            activo
              ? 'translateY(-1px) scale(1.03)'
              : 'translateY(0) scale(1)'
        }}
      >
        <span style={mobileStyles.iconContainer}>
          <Icon />
        </span>

        <span
          style={{
            ...mobileStyles.label,

            color: '#111111',

            fontWeight:
              activo ? '850' : '700'
          }}
        >
          {item.nombre}
        </span>
      </span>
    </button>
  );
};

  const desktopMenuItems = [
    {
      id: 'mapa',
      icono: '🗺️',
      nombre: 'Mapa'
    },
    {
      id: 'vehiculos',
      icono: '🛡️',
      nombre: 'Activos'
    },
...(
      ['super_admin', 'admin_empresa', 'administrador'].includes(
        JSON.parse(localStorage.getItem('user') || '{}').role
      )
        ? [{
            id: 'administracion',
            icono: '🧩',
            nombre: 'Admin'
          }]
        : []
    ),
    {
      id: 'config',
      icono: '⚙️',
      nombre: 'Config'
    },
    {
      id: 'centinela',
      icono: iconocentinel,
      nombre: 'Centinela',
      premium: true
    }
  ];

  /* =========================================================
     NAVEGACIÓN MÓVIL
     ========================================================= */

if (isMobile) {
  const hubActivo =
    moduloActivo === 'camaras' ||
    moduloActivo === 'centinela';

return (
    <>


      <nav
  data-maccez-hub-root="true"
  style={mobileStyles.wrapper}
>
        <div style={mobileStyles.glassBar}>
        {mobileLeftItems.map(
          renderMobileItem
        )}

        <div style={mobileStyles.hubSlot}>
          <div
            style={{
              ...mobileStyles.hubActions,

              pointerEvents:
                hubAbierto
                  ? 'auto'
                  : 'none'
            }}
          >
            <button
              type="button"
              tabIndex={hubAbierto ? 0 : -1}
              aria-label="Abrir Cámaras"
              onClick={() => {
                navegarMovil('camaras');
              }}
              style={{
                ...mobileStyles.hubAction,
                ...mobileStyles.cameraAction,

                opacity:
                  hubAbierto ? 1 : 0,

                transform:
                  hubAbierto
                    ? 'translate3d(0, 0, 0) scale(1)'
                    : 'translate3d(72px, 58px, 0) scale(0.42)',

                transitionDelay:
                  hubAbierto
                    ? '35ms'
                    : '0ms'
              }}
            >
              <img src={diviCamaras} alt="" aria-hidden="true" draggable={false}
                style={mobileStyles.hubActionIcon} />

              <span style={mobileStyles.hubActionLabel}>
                Cámaras
              </span>
            </button>

            <button
              type="button"
              tabIndex={hubAbierto ? 0 : -1}
              aria-label="Abrir Centinela"
              onClick={() => {
                navegarMovil('centinela');
              }}
              style={{
                ...mobileStyles.hubAction,
                ...mobileStyles.sentinelAction,

                opacity:
                  hubAbierto ? 1 : 0,

                transform:
                  hubAbierto
                    ? 'translate3d(0, 0, 0) scale(1)'
                    : 'translate3d(-72px, 58px, 0) scale(0.42)',

                transitionDelay:
                  hubAbierto
                    ? '80ms'
                    : '0ms'
              }}
            >
              <img src={diviCentinela} alt="" aria-hidden="true" draggable={false}
                style={mobileStyles.sentinelActionIcon} />

              <span style={mobileStyles.hubActionLabel}>
                Centinela
              </span>
            </button>
          </div>

          <button
            type="button"
            aria-label={
              hubAbierto
               ? 'Cerrar funciones DIVI'
: 'Abrir funciones DIVI'
            }
            aria-expanded={hubAbierto}
          onClick={() => {
  const abrirHub =
    !hubAbierto;

  if (abrirHub) {
    window.dispatchEvent(
      new CustomEvent(
        'maccez:mobile-hub-open'
      )
    );
  }

  setHubAbierto(abrirHub);
}}
            style={{
              ...mobileStyles.hubButton,

              transform:
                hubAbierto
                  ? 'translateX(-50%) translateY(-5px) scale(1.07)'
                  : 'translateX(-50%) translateY(0) scale(1)',

              boxShadow:
                hubAbierto
                  ? `
                      0 14px 32px rgba(3,59,120,0.34),
                      0 5px 12px rgba(15,23,42,0.24),
                      inset 0 2px 2px rgba(255,255,255,0.95),
                      inset 0 -5px 9px rgba(2,31,68,0.24),
                      0 0 0 5px rgba(56,189,248,0.15)
                    `
                  : mobileStyles.hubButton.boxShadow
            }}
          >
            <span
              style={{
                ...mobileStyles.hubGlow,

                opacity:
                  hubAbierto ? 1 : 0.55
              }}
            />

     <img
  src="/icons/divi-icon-512-v1.png"
  alt=""
  aria-hidden="true"
  style={{
    ...mobileStyles.hubLogo,
    top: 0,
    borderRadius: '50%',

    transform: hubAbierto
      ? 'rotate(360deg) scale(1.10)'
      : 'rotate(0deg) scale(1)'
  }}
/>

      
          </button>

          {(hubAbierto || hubActivo) && (
            <span
              style={mobileStyles.hubActivePoint}
              aria-hidden="true"
            />
          )}
        </div>

      {mobileRightItems.map(
          renderMobileItem
        )}
        </div>
      </nav>
    </>
  );
}
  /* =========================================================
     SIDEBAR DE ESCRITORIO SIN CAMBIOS
     ========================================================= */

  return (
    <div style={desktopStyles.sidebar}>
      <div style={desktopStyles.logoContainer}>
        <img
          src={puzzleIcon}
          alt="MACCEZ"
          style={desktopStyles.logo}
        />
      </div>

      <div style={desktopStyles.menu}>
        {desktopMenuItems.map((item) => {
          const activo = moduloActivo === item.id;

          return (
            <div
              key={item.id}
              onClick={() => setModuloActivo(item.id)}
              style={{
                ...desktopStyles.item,

                height: item.premium ? '96px' : '64px',

                background: item.premium
                  ? activo
                    ? 'linear-gradient(145deg, rgba(245,158,11,0.34), rgba(15,23,42,0.92))'
                    : 'linear-gradient(145deg, rgba(245,158,11,0.18), rgba(15,23,42,0.58))'
                  : activo
                    ? 'linear-gradient(135deg, #1f5f9f, #256fb8)'
                    : 'rgba(15,23,42,0.38)',

                border: item.premium
                  ? '1px solid rgba(245,158,11,0.55)'
                  : activo
                    ? '1px solid rgba(96,165,250,0.35)'
                    : '1px solid rgba(148,163,184,0.10)',

                boxShadow: item.premium
                  ? '0 0 22px rgba(245,158,11,0.28)'
                  : activo
                    ? '0 10px 28px rgba(37,111,184,0.35)'
                    : 'none'
              }}
            >
              <div
                style={{
                  width: item.premium ? '66px' : '30px',
                  height: item.premium ? '66px' : '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  lineHeight: 1
                }}
              >
                {item.premium ? (
                  <img
                    src={item.icono}
                    alt={item.nombre}
                    style={{
                      width: '78px',
                      height: '78px',
                      objectFit: 'contain',

                      filter: activo
                        ? `
                            drop-shadow(0 0 6px rgba(245,158,11,1))
                            drop-shadow(0 0 16px rgba(245,158,11,0.9))
                            drop-shadow(0 0 28px rgba(245,158,11,0.7))
                          `
                        : `
                            drop-shadow(0 0 4px rgba(245,158,11,0.8))
                            drop-shadow(0 0 12px rgba(245,158,11,0.5))
                          `
                    }}
                  />
                ) : (
                  <span style={{ fontSize: '21px' }}>
                    {item.icono}
                  </span>
                )}
              </div>

              <div
                style={{
                  fontSize: '10px',
                  fontWeight: '800',
                  color: activo ? '#ffffff' : '#94a3b8',
                  lineHeight: 1
                }}
              >
                {item.nombre}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* =========================================================
   ESTILOS MÓVILES
   ========================================================= */

const mobileStyles = {
 

wrapper: {
  position: 'fixed',

left:
  'max(20px, env(safe-area-inset-left, 0px))',

right:
  'max(20px, env(safe-area-inset-right, 0px))',
  bottom: '0',

  zIndex: 12000,

  height: '78px',

  padding:
    '7px 0 calc(7px + env(safe-area-inset-bottom, 0px))',

  boxSizing: 'border-box',
  pointerEvents: 'none'
},

  glassBar: {
    width: '100%',
    height: '62px',

    display: 'grid',
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
    alignItems: 'center',

    padding: '4px',
    boxSizing: 'border-box',
    borderRadius: '22px',

    background: 'rgba(255,255,255,0.78)',

    WebkitBackdropFilter: 'blur(26px) saturate(165%)',
    backdropFilter: 'blur(26px) saturate(165%)',

    border: '1px solid rgba(255,255,255,0.88)',

    boxShadow:
      '0 12px 38px rgba(15,23,42,0.20), inset 0 1px 0 rgba(255,255,255,0.96)',

    pointerEvents: 'auto'
  },

  item: {
    position: 'relative',

    height: '54px',
    minWidth: '0',

    padding: '0 2px',

    border: '0',
    outline: 'none',
    background: 'transparent',

    cursor: 'pointer',
    borderRadius: '17px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    WebkitTapHighlightColor: 'transparent'
  },

activeCapsule: {
  position: 'absolute',

  top: '2px',
  left: '4px',
  right: '4px',
  bottom: '2px',

  borderRadius: '16px',

background:
  'linear-gradient(180deg, rgba(125,211,252,0.38), rgba(186,230,253,0.28))',

border: '1px solid rgba(255,255,255,0.75)',

  boxShadow:
    '0 6px 18px rgba(15,23,42,0.08), inset 0 1px 0 rgba(255,255,255,0.80)',

  backdropFilter: 'blur(12px)',

  WebkitBackdropFilter: 'blur(12px)',

  transition:
    'opacity 180ms ease, transform 220ms cubic-bezier(0.22,1,0.36,1)'
},

  content: {
    position: 'relative',
    zIndex: 2,

    width: '100%',
    height: '100%',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    gap: '2px',

    transition:
      'color 180ms ease, transform 220ms cubic-bezier(0.22, 1, 0.36, 1)'
  },

  iconContainer: {
    width: '25px',
    height: '25px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  label: {
    maxWidth: '100%',
    padding: '0 2px',

    fontSize: '8px',
    lineHeight: '9px',
    letterSpacing: '0.02px',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    transition: 'color 180ms ease'
  },
  

hubSlot: {
  position: 'relative',
  width: '100%',
  height: '54px',
  overflow: 'visible',
  zIndex: 8
},

hubButton: {
  position: 'absolute',
  left: '50%',
  bottom: '-1px',

  width: '66px',
  height: '66px',

  padding: 0,
  borderRadius: '50%',

  border:
    '2px solid rgba(255,255,255,0.94)',

  background:
    'linear-gradient(145deg, #f8fbff 0%, #dcecff 48%, #9cc9f4 100%)',

  boxShadow: `
    0 11px 25px rgba(3,59,120,0.28),
    0 4px 9px rgba(15,23,42,0.20),
    inset 0 2px 2px rgba(255,255,255,0.98),
    inset 0 -5px 9px rgba(2,31,68,0.20)
  `,

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  cursor: 'pointer',
  outline: 'none',

  overflow: 'hidden',
  zIndex: 12,

  WebkitTapHighlightColor: 'transparent',

  transition:
    'transform 280ms cubic-bezier(0.22,1,0.36,1), box-shadow 280ms ease'
},

hubGlow: {
  position: 'absolute',
  inset: '5px',
  borderRadius: '50%',

  background:
    'radial-gradient(circle at 38% 25%, rgba(255,255,255,0.92), rgba(56,189,248,0.18) 48%, rgba(3,59,120,0.18) 100%)',

  transition: 'opacity 220ms ease'
},

hubLogo: {
  position: 'relative',
  top: '3px',
  zIndex: 2,

  width: '57px',
  height: '57px',
  objectFit: 'contain',

  margin: 0,

  filter: `
    drop-shadow(0 5px 5px rgba(2,31,68,0.30))
    drop-shadow(0 0 7px rgba(56,189,248,0.30))
  `,

  transition:
    'transform 680ms cubic-bezier(0.22, 0.8, 0.26, 1)',

  willChange: 'transform'
},

hubActivePoint: {
  position: 'absolute',
  left: '50%',
  bottom: '-2px',

  width: '5px',
  height: '5px',

  borderRadius: '50%',
  background: '#168df2',

  boxShadow:
    '0 0 8px rgba(22,141,242,0.85)',

  transform: 'translateX(-50%)',
  zIndex: 14
},

hubActions: {
  position: 'absolute',

  left: '50%',
  bottom: '61px',

  width: '232px',
  height: '82px',

  transform: 'translateX(-50%)',

  zIndex: 10
},

hubAction: {
  position: 'absolute', bottom: '0',
  width: '92px', height: '62px', padding: '0',
  border: '0', background: 'transparent', boxShadow: 'none',
  color: '#0f172a',
  display: 'flex', flexDirection: 'column',
  alignItems: 'center', justifyContent: 'center', gap: '3px',
  cursor: 'pointer', WebkitTapHighlightColor: 'transparent',
  transition: 'opacity 180ms ease, transform 340ms cubic-bezier(0.22,1,0.36,1)'
},

cameraAction: {
  left: '0'
},

sentinelAction: {
  right: '0'
},

hubActionIcon: {
  width: '70px', height: '46px', objectFit: 'contain',
  display: 'block', flexShrink: 0, pointerEvents: 'none',
  filter: 'drop-shadow(0 2px 2px rgba(3,31,68,0.18))'
},

sentinelActionIcon: {
  width: '46px', height: '46px', objectFit: 'contain',
  display: 'block', flexShrink: 0, pointerEvents: 'none',
  filter: 'drop-shadow(0 2px 2px rgba(3,31,68,0.18))'
},

hubActionLabel: {
  color: '#0f172a',

  fontSize: '9px',
  lineHeight: '10px',
  fontWeight: '900',
  letterSpacing: '0.15px',

  whiteSpace: 'nowrap'
}
};

/* =========================================================
   ESTILOS SVG
   El color se hereda del botón seleccionado.
   ========================================================= */

const iconStyles = {
  svg: {
    width: '24px',
    height: '24px',

    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }
};

/* =========================================================
   ESTILOS DE ESCRITORIO
   ========================================================= */

const desktopStyles = {
  sidebar: {
    width: '82px',
    height: '100vh',

    background:
      'linear-gradient(180deg, #123f73 0%, #1f5f9f 52%, #0f355f 100%)',

    borderRight: '1px solid rgba(255,255,255,0.12)',

    padding: '14px 8px',

    zIndex: 4000,

    boxShadow: '10px 0 35px rgba(0,0,0,0.38)',

    color: '#e2e8f0',

    boxSizing: 'border-box',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  logoContainer: {
    width: '64px',
    height: '64px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    marginBottom: '18px'
  },

  logo: {
    width: '60px',
    height: '60px',
    objectFit: 'contain'
  },

  menu: {
    display: 'flex',
    flexDirection: 'column',

    gap: '12px',

    width: '100%',
    alignItems: 'center'
  },

  item: {
    width: '64px',
    borderRadius: '18px',

    cursor: 'pointer',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    gap: '5px',

    transition: '0.25s'
  }
};

export default Sidebar;